import { render, staticRenderFns } from "./vas.vue?vue&type=template&id=a398cc78&scoped=true&"
import script from "./vas.vue?vue&type=script&lang=js&"
export * from "./vas.vue?vue&type=script&lang=js&"
import style0 from "./vas.vue?vue&type=style&index=0&id=a398cc78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a398cc78",
  null
  
)

export default component.exports